import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  listarProveedoresAdmin,
  type ListarProveedoresParams,
} from "../services/proveedores-service";

/**
 * Listado PAGINADO (server-side) · los filtros y la página forman parte del
 * queryKey (refetch al cambiar). `keepPreviousData` evita el parpadeo al
 * teclear en la búsqueda. Las mutations invalidan por prefijo
 * `qk.adminProveedores`, que cubre todas las variantes de params.
 */
export const proveedoresAdminQueryOptions = (params: ListarProveedoresParams = {}) =>
  queryOptions({
    queryKey: [...qk.adminProveedores, params] as const,
    queryFn: () => listarProveedoresAdmin(params),
    placeholderData: keepPreviousData,
  });

export const useProveedoresAdmin = (params: ListarProveedoresParams = {}) =>
  useQuery(proveedoresAdminQueryOptions(params));
